module.exports = __webpack_public_path__ + "static/media/newline5.63cd330c.jpg";